interface AnimatedBackgroundProps {
  variant?: "green" | "blue";
}

const AnimatedBackground = ({ variant = "green" }: AnimatedBackgroundProps) => {
  const color = variant === "blue" 
    ? "bg-blue-400" 
    : "bg-accent";

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" style={{ opacity: 0.4 }}>
      {/* CSS-only animated dots — no JS, no requestAnimationFrame */}
      <div className={`absolute w-2 h-2 rounded-full ${color} blur-sm animate-[float1_20s_ease-in-out_infinite]`} style={{ top: '15%', left: '10%' }} />
      <div className={`absolute w-1.5 h-1.5 rounded-full ${color} blur-sm animate-[float2_25s_ease-in-out_infinite]`} style={{ top: '35%', left: '80%' }} />
      <div className={`absolute w-3 h-3 rounded-full ${color} blur-md animate-[float3_22s_ease-in-out_infinite]`} style={{ top: '60%', left: '25%' }} />
      <div className={`absolute w-1 h-1 rounded-full ${color} blur-sm animate-[float1_18s_ease-in-out_infinite_reverse]`} style={{ top: '80%', left: '70%' }} />
      <div className={`absolute w-2 h-2 rounded-full ${color} blur-sm animate-[float2_23s_ease-in-out_infinite]`} style={{ top: '25%', left: '50%' }} />
      <div className={`absolute w-1.5 h-1.5 rounded-full ${color} blur-sm animate-[float3_19s_ease-in-out_infinite_reverse]`} style={{ top: '70%', left: '40%' }} />
    </div>
  );
};

export default AnimatedBackground;
